import { render } from "./TagespauschaleKostenSignal.pug?vue&type=template&id=35a4a213&lang=pug"
import script from "./TagespauschaleKostenSignal.js?vue&type=script&lang=js"
export * from "./TagespauschaleKostenSignal.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__